import React from 'react';
import { Helmet } from 'react-helmet-async';
import { pathWithRegion } from '../../utils/navBase';
import { PUBLIC_REGION_CODES, REGION_HREFLANG } from '../../config/publicRegions';

function getSiteUrl() {
  if (process.env.REACT_APP_SITE_URL) return process.env.REACT_APP_SITE_URL;
  if (typeof window !== 'undefined') return window.location.origin;
  return 'https://fliqmatch.com';
}

export default function SEO({
  title,
  description = '',
  path = '/',
  region = '',
  image = '',
  noindex = false,
  keywords = [],
  jsonLd = null,
}) {
  const site = getSiteUrl().replace(/\/+$/, '');
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  const currentPath = pathWithRegion(cleanPath, region);
  const canonical = `${site}${currentPath}`;
  const defaultImage = `${site}/logo192.png`;
  const robots = noindex ? 'noindex, nofollow' : 'index, follow';
  const locale = REGION_HREFLANG[region] || 'en-US';

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords.length ? <meta name="keywords" content={keywords.join(', ')} /> : null}
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image || defaultImage} />
      <meta property="og:locale" content={locale} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image || defaultImage} />

      {PUBLIC_REGION_CODES.map((r) => {
        const href = `${site}${pathWithRegion(cleanPath, r === 'us' ? '' : r)}`;
        const hreflang = REGION_HREFLANG[r] || 'en-US';
        return <link key={r} rel="alternate" hrefLang={hreflang} href={href} />;
      })}
      <link rel="alternate" hrefLang="x-default" href={`${site}${cleanPath}`} />
      {(Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : []).map((entry, idx) => (
        <script key={`jsonld-${idx}`} type="application/ld+json">
          {JSON.stringify(entry)}
        </script>
      ))}
    </Helmet>
  );
}
